import React from 'react';
import NavMec from '../Components/Nav/NavMec'
import Footer from '../Components/Footer/Footer';
import TeamMec from '../Components/TeamMec/TeamMec';

const TeamPageMac = () => {
    return (
        <div className="App">
            <NavMec />
            <TeamMec />
            <Footer />
        </div>
    )
}

export default TeamPageMac;